import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {InvestmentOfferTypeSlug} from "../constants/investment_offer_constants";

interface IHook {
    listUrl: string;
    mapUrl: string;
}

export const useInvestmentOfferViewsUrl = (): IHook => {
    const category = useSelector((state: IRPStore) => state.investmentOffer.categories.category);
    const subcategory = useSelector((state: IRPStore) => state.investmentOffer.categories.subcategory);

    const listUrl = (() => {
        if (category && subcategory) {
            return rpAppLink.investmentOffer.investmentCategory.subcategory.base({category, subcategory});
        }
        return category
            ? rpAppLink.investmentOffer.investmentCategory.base({category})
            : rpAppLink.investmentOffer.investmentCategory.base({category: InvestmentOfferTypeSlug.INVESTMENT});
    })();

    const mapUrl = (() => {
        if (category && subcategory) {
            return rpAppLink.investmentOffer.investmentCategory.subcategory.map({category, subcategory});
        }

        return category
            ? rpAppLink.investmentOffer.investmentCategory.map({category})
            : rpAppLink.investmentOffer.investmentCategory.map({category: InvestmentOfferTypeSlug.INVESTMENT});
    })();

    return {
        listUrl,
        mapUrl
    };
};
import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {InvestmentOfferTypeSlug} from "../constants/investment_offer_constants";

interface IHook {
    listUrl: string;
    mapUrl: string;
}

export const useInvestmentOfferViewsUrl = (): IHook => {
    const category = useSelector((state: IRPStore) => state.investmentOffer.categories.category);
    const subcategory = useSelector((state: IRPStore) => state.investmentOffer.categories.subcategory);

    const listUrl = (() => {
        if (category && subcategory) {
            return rpAppLink.investmentOffer.investmentCategory.subcategory.base({category, subcategory});
        }
        return category
            ? rpAppLink.investmentOffer.investmentCategory.base({category})
            : rpAppLink.investmentOffer.investmentCategory.base({category: InvestmentOfferTypeSlug.INVESTMENT});
    })();

    const mapUrl = (() => {
        if (category && subcategory) {
            return rpAppLink.investmentOffer.investmentCategory.subcategory.map({category, subcategory});
        }

        return category
            ? rpAppLink.investmentOffer.investmentCategory.map({category})
            : rpAppLink.investmentOffer.investmentCategory.map({category: InvestmentOfferTypeSlug.INVESTMENT});
    })();

    return {
        listUrl,
        mapUrl
    };
};
